module.exports = __webpack_public_path__ + "img/leona_street_ocular.d7d6ecd8.jpg";